var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinMascotCutted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 85,
    viewBox: "0 0 96 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.3228 69.4691V102.799",
    stroke: "black",
    strokeWidth: 7.08653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8336 69.4691V102.799",
    stroke: "black",
    strokeWidth: 7.08653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7306 40.1932C15.7306 40.1932 3.87043 46.1292 4.12312 52.5866C4.34893 58.3827 16.3005 60.3183 16.3005 60.3183",
    stroke: "black",
    strokeWidth: 7.08653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2751 64.1092L28.587 67.9105C28.087 73.4647 26.4687 77.7123 22.2052 78.8522C16.1192 80.7394 11.0547 77.0295 11.0547 73.6314C11.0547 72.2065 12.6461 71.8678 12.6461 71.8678C12.6461 71.8678 10.4472 70.4537 12.173 68.6256C12.845 67.9105 14.6784 68.5826 14.6784 68.5826C14.6784 68.5826 15.0386 66.6846 16.0977 66.3298C16.7321 66.1201 18.2805 66.8298 18.2805 66.8298L23.2751 64.1092Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.097 57.1138C19.097 57.1138 19.5164 58.3021 19.1454 59.8237C18.7314 61.5281 17.7905 62.3508 17.7905 62.3508C16.5753 63.2648 16.328 64.9961 17.2421 66.2112C18.1561 67.4264 19.8874 67.6737 21.1025 66.7597C21.1025 66.7597 23.5489 65.0391 24.506 61.1302C25.334 57.7268 24.2264 55.076 24.2264 55.076C23.6619 53.662 22.0596 52.9737 20.6455 53.5329C19.2314 54.0975 18.5432 55.6997 19.1024 57.1138H19.097Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.785002,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1621 72.5228H51.0761C68.7213 72.5228 83.0492 58.1938 83.0492 40.5474C83.0492 22.901 68.7213 8.57203 51.0761 8.57203",
    fill: "#AA7C00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8289 64.7756L66.1242 64.8508L70.0062 60.7914L75.8937 60.7L71.8289 64.7809V64.7756Z",
    fill: "#E7BB29"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.0057 66.3124L64.102 66.3823L60.8168 68.4254L67.6184 67.9093L70.0057 66.3124Z",
    fill: "#E7BB29"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.0752 27.0735L73.9404 26.7186C73.3113 25.2292 71.0101 21.7881 69.3218 19.8848L75.8921 20.4009C77.2793 22.2344 79.1343 25.2239 80.0752 27.0735Z",
    fill: "#F3E9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1618 72.5228C27.5035 72.5228 13.1886 58.2069 13.1886 40.5474C13.1886 22.8879 27.5035 8.57203 45.1618 8.57203C62.82 8.57203 77.1349 22.8879 77.1349 40.5474C77.1349 58.2069 62.82 72.5228 45.1618 72.5228Z",
    fill: "#ECD559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1618 72.5228C27.5035 72.5228 13.1886 58.2069 13.1886 40.5474C13.1886 22.8879 27.5035 8.57203 45.1618 8.57203C62.82 8.57203 77.1349 22.8879 77.1349 40.5474C77.1349 58.2069 62.82 72.5228 45.1618 72.5228Z",
    stroke: "black",
    strokeWidth: 0.785002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5918 40.548C21.5219 15.1107 45.2854 13.8418 44.9413 13.8418C30.1993 13.8418 18.237 25.8104 18.237 40.548C18.237 55.2856 30.2047 67.2542 44.9413 67.2542C45.2854 67.2542 21.0327 65.8078 20.5918 40.548Z",
    fill: "#A67705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1619 67.4743C30.2918 67.4743 18.2372 55.4188 18.2372 40.5476C18.2372 25.6764 30.2918 13.621 45.1619 13.621C60.0321 13.621 72.0867 25.6764 72.0867 40.5476C72.0867 55.4188 60.0321 67.4743 45.1619 67.4743Z",
    stroke: "black",
    strokeWidth: 0.785002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1621 72.5228H51.0761C68.7213 72.5228 83.0492 58.1938 83.0492 40.5474C83.0492 22.901 68.7213 8.57203 51.0761 8.57203",
    stroke: "black",
    strokeWidth: 0.785002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0759 8.5721H45.1615",
    stroke: "#0B1420",
    strokeWidth: 0.785002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0058 4.31396C54.538 2.65793 51.4034 1.62022 48.6397 2.38371",
    stroke: "black",
    strokeWidth: 3.15076,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1565 5.79719C32.3878 3.95835 35.3504 2.50663 38.1947 2.89376",
    stroke: "black",
    strokeWidth: 3.15076,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8771 39.0258C80.8771 39.0258 98.5545 44.9294 96.5814 52.6128C94.9362 59.0326 80.7104 58.8498 80.7104 58.8498",
    stroke: "black",
    strokeWidth: 7.08653,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0169 43.5744C52.0169 43.5744 48.0922 45.8972 43.9363 45.5961C39.7804 45.295 36.0707 43.94 36.0707 43.94C36.0707 43.94 35.3503 49.2415 38.2696 54.0805C41.189 58.9196 43.8449 59.796 46.5976 59.3336C49.3503 58.8712 52.6836 55.7957 53.818 50.9244C51.9632 49.22 51.0492 46.1284 52.0062 43.5744H52.0169Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1459 43.4355C47.2373 46.0701 41.5814 46.2475 35.9255 44.2635C35.9631 45.6883 36.0222 46.968 36.2749 48.2853C38.5921 50.721 47.2481 50.6726 51.7803 47.4304C51.3448 46.1454 51.6029 44.9894 52.1459 43.4355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4517 56.2851C45.7958 55.5485 46.2959 54.6237 47.7906 54.3495C49.7908 53.9839 51.2371 55.3926 51.2371 55.3926C51.2371 55.3926 50.1617 58.5057 46.355 59.0541C42.4623 59.6187 41.188 56.5432 41.188 56.5432C41.188 56.5432 41.4622 55.4732 42.7849 54.8872C43.7473 54.4624 44.9356 54.6183 46.0486 55.2313",
    fill: "#FF7EB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4517 56.2851C45.7958 55.5485 46.2959 54.6237 47.7906 54.3495C49.7908 53.9839 51.2371 55.3926 51.2371 55.3926C51.2371 55.3926 50.1617 58.5057 46.355 59.0541C42.4623 59.6187 41.188 56.5432 41.188 56.5432C41.188 56.5432 41.4622 55.4732 42.7849 54.8872C43.7473 54.4624 44.9356 54.6183 46.0486 55.2313",
    stroke: "black",
    strokeWidth: 0.785002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9091 40.5483C60.4519 38.6987 55.1773 39.0159 52.8331 42.2527C49.0264 47.5004 55.1128 53.4363 59.1722 54.3396",
    stroke: "black",
    strokeWidth: 0.785002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1459 43.435C46.0599 46.8654 39.5868 46.3062 32.7696 42.2521",
    stroke: "black",
    strokeWidth: 0.785002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8443 50.9304C53.0217 54.3392 50.3873 59.2051 45.6561 59.3342C38.5271 59.5331 35.3711 48.8119 36.1185 43.9675",
    stroke: "black",
    strokeWidth: 0.785002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1404 39.8704C35.9329 39.8704 32.5221 35.5758 32.5221 30.2783C32.5221 24.9807 35.9329 20.6862 40.1404 20.6862C44.3478 20.6862 47.7587 24.9807 47.7587 30.2783C47.7587 35.5758 44.3478 39.8704 40.1404 39.8704Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.785002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1508 37.6285C45.4141 36.8812 43.8764 35.4671 41.9515 35.1821C39.6987 34.8488 37.6501 35.5746 37.0049 37.3382C36.1662 39.6394 37.9943 42.3869 40.8278 43.1182C42.1558 43.4623 43.742 43.4031 45.0862 42.7794",
    fill: "#ECD559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1508 37.6285C45.4141 36.8812 43.8764 35.4671 41.9515 35.1821C39.6987 34.8488 37.6501 35.5746 37.0049 37.3382C36.1662 39.6394 37.9943 42.3869 40.8278 43.1182C42.1558 43.4623 43.742 43.4031 45.0862 42.7794",
    stroke: "black",
    strokeWidth: 0.785002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0549 39.8704C46.8474 39.8704 43.4366 35.5758 43.4366 30.2783C43.4366 24.9807 46.8474 20.6862 51.0549 20.6862C55.2624 20.6862 58.6732 24.9807 58.6732 30.2783C58.6732 35.5758 55.2624 39.8704 51.0549 39.8704Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.785002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7532 26.6118C48.8175 26.6118 47.2422 28.5904 47.2422 31.0314C47.2422 33.4725 48.8122 35.4511 50.7532 35.4511C52.5812 35.4511 53.9631 33.537 54.0921 32.4079L51.0005 30.983L54.0383 29.4722C53.7856 28.1441 52.463 26.6118 50.7532 26.6171V26.6118Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0914 25.9074C38.1558 25.9074 36.5804 27.8861 36.5804 30.3271C36.5804 32.7681 38.1504 34.7468 40.0914 34.7468C41.9195 34.7468 43.3013 32.8327 43.4303 31.7036L40.3387 30.2787L43.3766 28.7679C43.1239 27.4398 41.8012 25.9074 40.0914 25.9128V25.9074Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7736 66.3563L81.2306 66.6574C82.8113 67.964 83.6392 68.8619 83.3489 69.9372L83.9564 70.405C83.9564 70.405 85.9618 68.878 87.1822 69.534C90.6285 71.3997 87.9887 74.1364 87.9887 74.1364C87.9887 74.1364 89.6231 76.4861 87.0747 77.5722C85.3489 78.3088 79.5425 81.2068 73.0908 74.6795C64.521 65.9961 73.0586 54.9254 75.0263 54.8125C75.0263 54.8125 74.279 63.9045 79.7736 66.3617V66.3563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.726 56.1998C80.726 56.1998 80.3066 57.3881 80.6776 58.9097C81.0916 60.6141 82.0326 61.4368 82.0326 61.4368C83.2477 62.3508 83.495 64.0821 82.581 65.2973C81.6669 66.5124 79.9356 66.7597 78.7205 65.8457C78.7205 65.8457 76.2741 64.1251 75.317 60.2162C74.489 56.8128 75.5966 54.1621 75.5966 54.1621C76.1612 52.748 77.7634 52.0598 79.1775 52.6189C80.5916 53.1835 81.2798 54.7858 80.7206 56.1998H80.726Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.785002,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7524 66.3564C79.8922 67.8404 79.2147 70.3352 78.0264 71.3998",
    stroke: "black",
    strokeWidth: 0.785002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2639 70.9376C78.2585 71.3355 79.7693 73.3518 79.7693 73.3518C80.6133 73.9378 82.1187 73.9647 83.0918 73.6098C83.0918 73.6098 84.9951 72.5506 86.9574 73.3249C88.78 74.04 88.737 76.5133 87.2693 77.4542C85.5918 78.5295 81.323 79.82 76.7262 77.4273C69.7424 73.7873 67.9789 65.6684 70.8929 59.5336C71.8338 57.5549 73.6026 55.786 75.409 54.5386",
    stroke: "black",
    strokeWidth: 0.785002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.984 74.1362C89.1454 72.5447 89.2422 70.6306 87.7421 69.7811C86.1237 68.8617 84.8225 69.8241 83.0804 70.9801C81.4405 72.0662 79.6178 72.2221 78.7307 72.0931",
    stroke: "black",
    strokeWidth: 0.785002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8932 70.2858C83.8932 70.2858 83.2641 70.0116 82.463 70.2966C81.4145 70.673 79.8983 70.7751 78.8068 70.3611",
    stroke: "black",
    strokeWidth: 0.785002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7693 66.3564C81.7156 66.9855 83.9846 68.2436 83.1781 70.1739",
    stroke: "black",
    strokeWidth: 0.785002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.135 67.1352C17.5544 69.4149 18.3609 72.5227 19.9846 74.0604",
    stroke: "black",
    strokeWidth: 0.785002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.587 67.9049C28.4042 70.3997 27.4741 76.4109 23.8397 78.2067C21.1139 79.5509 17.4848 79.7444 15.13 78.5562C12.6945 77.3303 10.8289 74.8193 11.0816 73.4644C11.302 72.2654 12.2429 71.8353 13.3235 71.9751C14.9257 72.1794 15.9364 73.5182 16.9526 74.6365",
    stroke: "black",
    strokeWidth: 0.785002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.022 73.0721C19.022 73.0721 18.7155 73.2442 18.651 73.2872C18.3983 73.4378 18.1564 73.6152 17.9252 73.7926C17.2208 74.3249 16.6079 74.9379 16.0971 75.653",
    stroke: "black",
    strokeWidth: 0.785002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6502 71.8621C12.6986 71.8944 11.8545 71.3137 11.6071 70.5986C11.2845 69.6577 11.6985 68.6307 12.7416 68.3673C15.0052 67.7866 18.2044 70.8083 18.9679 72.7224",
    stroke: "black",
    strokeWidth: 0.785002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9194 68.6197C14.1021 67.7864 15.4409 65.5389 17.5594 66.6088",
    stroke: "black",
    strokeWidth: 0.785002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_72"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 126.891,
    fill: "white",
    transform: "matrix(-1 0 0 1 100.5 0.109375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinMascotCutted);
export default __webpack_public_path__ + "static/media/Coin_Mascot_Cutted.5852ebfeaa435d8e656bb42f5aacbfb6.svg";
export { ForwardRef as ReactComponent };